import React, { Children } from 'react';
import PropTypes from 'prop-types';

// ====

// ====

const Main = (props) => {
  const { children } = props;

  // ====

  return <main className="brand-body brand-font">{children}</main>;
};

export default Main;

// ====

Main.propTypes = {};

Main.defaultProps = {};
